import { render, staticRenderFns } from "./IconWave.vue?vue&type=template&id=30125e47&"
import script from "./IconWave.vue?vue&type=script&lang=js&"
export * from "./IconWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports